import '@formkit/themes/genesis'
import { defaultConfig, plugin } from '@formkit/vue'
import '@vueform/toggle/themes/default.css'
import VCalendar from 'v-calendar'
import { createApp } from 'vue'
import { vfmPlugin } from 'vue-final-modal'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import Accounting from './pages/Accounting.vue'
import ApplyPunch from './pages/ApplyPunch.vue'
import Attendance from './pages/Attendance.vue'
import CompensatoryLeave from './pages/CompensatoryLeave.vue'
import Leave from './pages/Leave.vue'
import Overtime from './pages/Overtime.vue'
import Rules from './pages/Rules.vue'

const createSingleApp = options => {
  const setting = {}
  return createApp(options).use(Toast, setting).use(plugin, defaultConfig)
}

require('./bootstrap')

createSingleApp(Attendance).use(VCalendar, {}).use(vfmPlugin).mount('#attendance')

createSingleApp(Rules).use(vfmPlugin).mount('#rule')

createSingleApp(ApplyPunch).use(VCalendar, {}).mount('#applyPunch')

createSingleApp(Leave).use(vfmPlugin).mount('#leave')

createSingleApp(Accounting).use(vfmPlugin).mount('#accounting')

createSingleApp(CompensatoryLeave).use(vfmPlugin).mount('#compensatory-leave')

createSingleApp(Overtime).use(vfmPlugin).mount('#overtime')
